var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sidebar-page"},[_c('section',{staticClass:"sidebar-layout"},[_c('Sidebar'),_c('div',{staticClass:"main-view"},[(_vm.hasTopBar)?_c('Topbar'):_vm._e(),_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }